import { render } from "./CommentarySingle.vue?vue&type=template&id=791f5759&ts=true"
import script from "./CommentarySingle.vue?vue&type=script&lang=ts"
export * from "./CommentarySingle.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__